function toggleAnswer(element) {
    const answer = element.nextElementSibling;
    const icon = element.querySelector('.toggle-icon');

    if (answer.style.display === "none" || answer.style.display === "") {
        answer.style.display = "block";
        icon.textContent = "-";
        element.style.borderBottom = "none";
        answer.classList.add('active');
    } else {
        answer.style.display = "none";
        icon.textContent = "+";
        element.style.borderBottom = "1px solid #000000";
        answer.classList.remove('active');
    }
}